import { render, staticRenderFns } from "./ModalFilterTickets.vue?vue&type=template&id=dd90a1e4&"
import script from "./ModalFilterTickets.vue?vue&type=script&lang=ts&"
export * from "./ModalFilterTickets.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports